import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { FormattedNumber } from "react-intl";

import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Big from "big.js";
import { fn } from "util";

import {
  CheckBox,
  DescriptionField,
  IconButton,
  Loadable,
  Page
} from "components/support";

class OptionalForm extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { title, loading, form } = viewModel;
    let value = "";
    if (form.value) {
      value = Big(form.value)
        .div(100)
        .toFixed(2);
    }

    return (
      <div className="grid-container">
        <Page>
          <Row>
            <Col xs={12}>
              <Typography type="display1" className="pb-sm">
                <Row>
                  <Col xs>
                    <IconButton
                      icon="arrow_back"
                      onClick={() => presenter.onGoBack()}
                    />
                    {title}
                  </Col>
                  <Col>
                    <IconButton
                      icon="mode_edit"
                      onClick={() => presenter.onEdit()}
                    />
                    <IconButton
                      icon="delete"
                      onClick={() => presenter.onDeleteOptionalGroup()}
                    />
                  </Col>
                </Row>
              </Typography>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Loadable loading={loading}>
                <Paper elevation={1}>
                  <div className="grid-container">
                    <Row>
                      <Col xs={12} lg={6}>
                        <DescriptionField
                          value={form.name}
                          label="Nome do Grupo"
                        />
                      </Col>
                      <Col xs={12} lg={6}>
                        <FormattedNumber value={value || 0} format="BRL">
                          {value => (
                            <DescriptionField
                              label="Preço do Opcional"
                              value={value}
                            />
                          )}
                        </FormattedNumber>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} lg={6}>
                        <Row className="ph-sm">
                          <Col xs={12}>
                            <CheckBox
                              disabled
                              style={{
                                marginTop: "7px",
                                paddingBottom: "-4px"
                              }}
                              checked={form.mandatory}
                              label="Quantidade obrigatória de opcionais por cliente"
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <DescriptionField
                              style={{ margin: "0px" }}
                              value={form.mandatory_quantity || ""}
                            />
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={12} lg={6}>
                        <Row className="ph-sm">
                          <Col xs={12}>
                            <CheckBox
                              disabled
                              style={{
                                marginTop: "7px",
                                paddingBottom: "-4px"
                              }}
                              checked={form.limited}
                              label="Quantidade máxima de opcionais por cliente"
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <DescriptionField
                              style={{ margin: "0px" }}
                              value={form.limited_value || ""}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {form.optionals.map((optional, i) => (
                      <Row key={i}>
                        <Col xs={5}>
                          <DescriptionField
                            value={optional.name}
                            label={`Nome do item ${i + 1}`}
                          />
                        </Col>

                        <Col xs={5}>
                          <FormattedNumber
                            value={fn.centsToReal(optional.value)}
                            format="BRL"
                          >
                            {value => (
                              <DescriptionField
                                value={value}
                                label={`Valor do item ${i + 1}`}
                              />
                            )}
                          </FormattedNumber>
                        </Col>

                        <Col xs>
                          <CheckBox
                            disabled
                            style={{ paddingTop: 30 }}
                            checked={optional.mandatory}
                            label="Obrigatório"
                          />
                        </Col>
                      </Row>
                    ))}
                  </div>
                </Paper>
              </Loadable>
            </Col>
          </Row>
        </Page>
      </div>
    );
  }
}

export default OptionalForm;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/info/view.jsx